<div class="container-fluid">
    <h1 class="header">{{ 'Sections.Administration' | translate }}</h1>

    <mat-tab-group (selectedTabChange)="onTabChanged($event)" mat-stretch-tabs="false">
        @for (tab of tabs; track tab.link) {
            <mat-tab [label]="tab.label | translate"></mat-tab>
        }
    </mat-tab-group>

    <router-outlet></router-outlet>
</div>
